export default {
  SUCCESS: 'app/projects/SUCCESS',
  FAILURE: 'app/projects/FAILURE'
}



// WEBPACK FOOTER //
// ./store/projects/constants/index.js